import { createBrowserHistory, createMemoryHistory, createHashHistory, } from 'history';
import { getFullPath, isEmbedded } from './location';
import isBrowserInFullScreenMode from './isBrowserInFullScreenMode';
// Create an enhanced history used to trigger navigation events
export function createEnhancedHistory(_a) {
    var _b = _a === void 0 ? {} : _a, isAppBuild = _b.isAppBuild, isDownloaded = _b.isDownloaded;
    var enhancedHistory;
    if (
    // wen can't use history.pushState() in tests
    process.env.NODE_ENV === 'test' ||
        // Prevent embedded prototypes hijacking the host page's history
        isEmbedded() ||
        // The player runs from the local file system when is dowloaded as zip
        window.location.protocol === 'file:' ||
        // The webview that app builds use don't implement browser
        // history properly
        isAppBuild) {
        enhancedHistory = createMemoryHistory({ initialEntries: [getFullPath()] });
    }
    else if (isDownloaded || isBrowserInFullScreenMode()) {
        enhancedHistory = createHashHistory();
    }
    else {
        enhancedHistory = createBrowserHistory();
    }
    return enhancedHistory;
}
